// Page1.js
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Button,
  TextField,
  Typography,
  IconButton,
  Stack,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { useTranslation } from "react-i18next";
import AddIcon from "@mui/icons-material/Add";

function Page1() {
  const { t } = useTranslation();
  const [defaults, setDefaults] = useState({
    title: `${t("Schedule")} - ${new Date().toISOString().slice(0, 10)}`,
    numDays: 30,
    numPeople: 10,
    shifts: [{ id: 1, name: t("defaultShift") }],
    maxShiftsPerPerson: 3,
    minEmptyDaysBetweenShifts: 1,
  });

  const [nextId, setNextId] = useState(2);
  const navigate = useNavigate();

  const handleShiftNameChange = (id, newName) => {
    setDefaults((prev) => ({
      ...prev,
      shifts: prev.shifts.map((shift) =>
        shift.id === id ? { ...shift, name: newName } : shift
      ),
    }));
  };

  const addShift = () => {
    setDefaults((prev) => ({
      ...prev,
      shifts: [...prev.shifts, { id: nextId, name: `${t("shift")} ${nextId}` }],
    }));
    setNextId((id) => id + 1);
  };

  const deleteShift = (id) => {
    setDefaults((prev) => ({
      ...prev,
      shifts: prev.shifts.filter((shift) => shift.id !== id),
    }));
  };

  const handleDefaultChange = (e) => {
    const { name, value } = e.target;
    setDefaults((prev) => ({
      ...prev,
      [name]: Number(value),
    }));
  };
  const handleTitleChange = (e) => {
    const { value } = e.target;

    setDefaults((prev) => ({
      ...prev,
      title: value,
    }));
  };

  const handleNext = async () => {
    navigate("/edit", { state: defaults });
  };

  return (
    <Box
      sx={{
        p: 3,
        maxWidth: 500,
        mx: "auto",
        backgroundColor: "#F5F5F5",
        borderRadius: "12px",
      }}
    >
      <Typography variant="h5" gutterBottom>
        {t("page1_title")}
      </Typography>

      <Stack spacing={2}>
        <TextField
          label={t("Title")}
          fullWidth
          name="title"
          value={defaults.title}
          onChange={handleTitleChange}
          inputProps={{ minLength: 1 }}
        />

        <TextField
          label={t("page1_days")}
          type="number"
          name="numDays"
          value={defaults.numDays}
          onChange={handleDefaultChange}
          inputProps={{ min: 1 }}
        />

        <TextField
          label={t("page1_people")}
          type="number"
          name="numPeople"
          value={defaults.numPeople}
          onChange={handleDefaultChange}
          inputProps={{ min: 1 }}
        />
      </Stack>

      <Typography variant="h6" sx={{ mt: 3 }}>
        {t("page1_ShiftsperDay")}
      </Typography>

      <Stack spacing={1}>
        {defaults.shifts.map((shift) => (
          <Box key={shift.id} sx={{ display: "flex", alignItems: "center" }}>
            <TextField
              value={shift.name}
              onChange={(e) => handleShiftNameChange(shift.id, e.target.value)}
              fullWidth
            />
            <IconButton
              onClick={() => deleteShift(shift.id)}
              size="small"
              disabled={defaults.shifts.length === 1}
              sx={{ ml: 1 }}
              title={
                defaults.shifts.length === 1
                  ? t("atLeastOneShift")
                  : t("deleteShift")
              }
            >
              <DeleteIcon />
            </IconButton>
          </Box>
        ))}

        <Button
          onClick={addShift}
          variant="outlined"
          startIcon={<AddIcon />}
          sx={{ alignSelf: "flex-start" }}
        >
          {t("Add")}
        </Button>
      </Stack>

      <Typography variant="h6" sx={{ mt: 3 }}>
        {t("defaultsForPeople")}
      </Typography>

      <Stack spacing={2}>
        <TextField
          label={t("maxShiftsPerPerson")}
          type="number"
          name="maxShiftsPerPerson"
          value={defaults.maxShiftsPerPerson}
          onChange={handleDefaultChange}
          inputProps={{ min: 1 }}
        />

        <TextField
          label={t("minEmptyDaysBetweenShifts")}
          type="number"
          name="minEmptyDaysBetweenShifts"
          value={defaults.minEmptyDaysBetweenShifts}
          onChange={handleDefaultChange}
          inputProps={{ min: 0 }}
        />
      </Stack>

      <Button
        onClick={handleNext}
        variant="contained"
        sx={{ mt: 3 }}
        fullWidth
        color="secondary"
      >
        {t("next")}
      </Button>
    </Box>
  );
}

export default Page1;
